/**
 * Helpers partages pour avatars utilisateurs.
 *
 * Avant cette factorisation, `resolveUrl` et `initials` etaient duplique
 * mot-pour-mot dans 20 composants (tasks/, memos/, feed/, planning/, etc.).
 * On centralise ici. La PR d'origine ne migrait que les composants tasks/
 * « pour limiter le risque de regression » et renvoyait le reste a une PR de
 * balayage : c'est celle-ci, 24 fichiers de plus.
 *
 * Les copies n'etaient PAS identiques — 6 variantes de `resolveUrl`, 11 de
 * `initials` — et les deux differences reelles sont absorbees ici plutot que
 * laissees en exception : le passe-plat `blob:` et le caractere de repli.
 */

/**
 * Resout une URL d'avatar/upload :
 * - undefined si vide
 * - URL absolue inchangee (http://, https://)
 * - chemin relatif prefixe par REACT_APP_BACKEND_URL (ex: /uploads/avatars/x.png)
 */
export function resolveUrl(u) {
  if (!u) return undefined;
  // `blob:` — apercu local d'une image AVANT son televersement
  // (URL.createObjectURL). Une seule des six copies le gerait ; les autres
  // prefixaient l'URL du backend devant, ce qui affichait une image cassee.
  // Le passe-plat est absorbe ici plutot que laisse en exception : il est
  // strictement plus permissif, donc sans effet sur les appelants qui ne
  // voient jamais de blob.
  if (u.startsWith("http") || u.startsWith("blob:")) return u;
  return `${process.env.REACT_APP_BACKEND_URL || ""}${u}`;
}

/**
 * Genere les initiales (2 lettres max) d'un nom complet pour AvatarFallback.
 * "Jean Dupont" -> "JD", "Marie" -> "M", "" -> "?".
 *
 * `secours` existe pour un seul appelant : le menu utilisateur affiche « U »
 * et non « ? » quand le nom manque. C'etait la seule difference VISIBLE entre
 * les onze copies — la parametrer preserve l'ecran au lieu de l'aligner en
 * douce sur la majorite.
 */
export function initials(name = "", secours = "?") {
  return (
    String(name || "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase())
      .join("") || secours
  );
}
